module.exports = __webpack_public_path__ + "img/af_icon_dark.c71e8235.svg";